import Decimal from "../../module/storemanagement/decimal.mjs";

export default class CalculationUtils {


    static roundNearest9(value) {
        const floor = value.floor();

        if (value.eq(floor)) return value;

        const fractional = value.minus(floor);
        const cents = Math.round(fractional.times(100).toNumber());

        let lowerCents = Math.floor(cents / 10) * 10 + 9;
        if (lowerCents > cents) lowerCents -= 10;

        let upperCents = Math.floor(cents / 10) * 10 + 9;
        if (upperCents < cents) upperCents += 10;

        const diffLower = Math.abs(cents - lowerCents);
        const diffUpper = Math.abs(upperCents - cents);

        let adjustedCents = diffLower <= diffUpper ? lowerCents : upperCents;

        // ❗ Negatif veya 0 olmasın
        if (adjustedCents <= 0) adjustedCents = 9;

        const adjustedFraction = adjustedCents / 100;
        return floor.plus(adjustedFraction);
    }

    static roundNearest49_99(value) {
        const floor = value.floor();
        const diff = value.minus(floor);

        if (diff.eq(0)) {
            return value;
        }

        const candidate49 = floor.plus(0.49);
        const candidate99 = floor.plus(0.99);

        const diff49 = value.minus(candidate49).abs();
        const diff99 = value.minus(candidate99).abs();

        let result = diff49.lte(diff99) ? candidate49 : candidate99;

        // ❗ Negatif veya 0 olmasın
        if (result.lte(0)) result = new Decimal(0.49);

        return result;
    }

    static roundNearest00(value) {
        const floor = value.floor();
        const diff = value.minus(floor);

        if (diff.eq(0)) {
            return value;
        }

        const candidate00 = floor.plus(0.00);
        const candidate100 = floor.plus(1.00);

        const diff00 = value.minus(candidate00).abs();
        const diff100 = value.minus(candidate100).abs();

        let result = diff00.lte(diff100) ? candidate00 : candidate100;

        // ❗ Negatif veya 0 olmasın
        if (result.lte(0)) result = new Decimal(0.01);

        return result;
    }

    static roundNearest50(value) {
        const floor = value.floor();
        const diff = value.minus(floor);

        if (diff.eq(0)) {
            return value;
        }

        const candidate00 = floor.plus(0.00);
        const candidate50 = floor.plus(0.50);
        const candidate100 = floor.plus(1.00);

        const diff00 = value.minus(candidate00).abs();
        const diff50 = value.minus(candidate50).abs();
        const diff100 = value.minus(candidate100).abs();

        let result;

        if (diff50.lte(diff00) && diff50.lte(diff100)) {
            result = candidate50;
        } else if (diff00.lte(diff100)) {
            result = candidate00;
        } else {
            result = candidate100;
        }

        // ❗ Negatif veya 0 olmasın
        if (result.lte(0)) result = new Decimal(0.50);

        return result;
    }
}
